import React, { useState } from 'react';
import {Container, Row, Col} from 'react-bootstrap';

const Interested = () => {
    return(
        <>
        <footer className='bottom-footer'>
            <div className='footer_wrap'>
                <p className='copy_rigth'><a target='_blnak' href="https://www.saluto.in/">Powered by saluto.in</a></p>
            </div>
        </footer>
        </>
    )
}

export default Interested;